<template>
    <div>
        <v-tabs v-model="tab" grow>
            <v-tab>INFO</v-tab>
            <v-tab>VENDITE</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card id="create-point-modal">
                    <v-card-title> Armadio </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-select
                                    :items="racks"
                                    item-text="description"
                                    item-value="id"
                                    label="Scegli l'armadio"
                                    v-model="selectedRack"
                                    return-object
                                ></v-select>
                            </v-col>
                            <v-col> &nbsp; </v-col>
                        </v-row>
                        <v-row v-if="selectedRack">
                            <v-col>
                                <div>Immaigine di riferimento</div>
                                <v-img
                                    :src="selectedRack.image"
                                    max-height="330"
                                    max-width="230"
                                    contain
                                />
                            </v-col>
                            <v-col> &nbsp; </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-textarea
                                    filled
                                    label="Note"
                                    auto-grow
                                    v-model="note"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="error"
                            text
                            v-if="isUpdate"
                            @click="onDelete"
                        >
                            elimina
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="$emit('closeDialog')"
                        >
                            Cancel
                        </v-btn>
                        <v-btn color="primary" @click="onSave"> Salva </v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card>
                    <v-card-title>
                        Vendite
                        <v-spacer></v-spacer>
                        <v-radio-group
                            v-model="filterVendite"
                            row
                            @change="setFilterVendite"
                        >
                            <v-radio label="Tutti" value="tutti"></v-radio>
                            <v-radio label="Venduti" value="ventuti"></v-radio>
                            <v-radio
                                label="Non Venduti"
                                value="non_venduti"
                            ></v-radio>
                        </v-radio-group>
                    </v-card-title>
                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead style="background-color: #eee">
                                    <tr>
                                        <th>IMMAGINE</th>
                                        <th>CODICE</th>
                                        <th>DESCRIZIONE</th>
                                        <th>PREZZO</th>
                                        <th>QTY</th>
                                        <th>TOTALE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="prod in prodSellData"
                                        :key="prod.id"
                                    >
                                        <td style="padding: 2px 0">
                                            <router-link
                                                target="_blank"
                                                :to="{
                                                    name: 'product',
                                                    query: {
                                                        id: prod.cod_articolo,
                                                    },
                                                }"
                                            >
                                                <v-img
                                                    :src="
                                                        imagePath(
                                                            prod.cod_articolo
                                                        )
                                                    "
                                                    width="80"
                                                    height="80"
                                                ></v-img>
                                            </router-link>
                                        </td>
                                        <td>{{ prod.cod_articolo }}</td>
                                        <td>{{ prod.ar_descr }}</td>
                                        <td>
                                            {{ prod.lc_prezzo2 | formatEuro }}
                                        </td>
                                        <td>
                                            {{ prod.qty_tot }}
                                        </td>
                                        <td>
                                            {{ prod.prezzo_tot | formatEuro }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>
<script>
import requests from "../../../requests";
import helpers from "../../../helpers";
import _ from "lodash";

let OriginalProductList = [];
export default {
    name: "create-point-modal",
    props: {
        racks: {
            type: Array,
            default: [],
        },
        open: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        open(value) {
            if (value) {
                this.selectedRack = null;
                this.note = null;
                this.markerId = null;
                this.isUpdate = false;
            }
        },
    },

    data() {
        return {
            selectedRack: null,
            note: null,
            isUpdate: false,
            markerId: null,
            tab: "INFO",
            prodSellData: [],
            filterVendite: "tutti",
        };
    },

    methods: {
        onSave() {
            this.$emit("onSave", this.selectedRack, this.note, this.markerId);
            this.isUpdate = false;
        },
        loadMarker(id, productSells = []) {
            this.isUpdate = true;
            this.markerId = id;
            OriginalProductList = _.cloneDeep(productSells);
            this.setFilterVendite();

            requests.getMarkerById(id).then((res) => {
                this.selectedRack = _.find(this.racks, {
                    id: res.data.rack_id,
                });
                this.note = res.data.note;
            });
        },
        onDelete() {
            if (window.confirm("Cancellare il marker?")) {
                requests.deleteMarker(this.markerId).then((res) => {
                    this.$emit("deleted");
                });
            }
        },
        imagePath(prodId) {
            if (!this.error) {
                return helpers.getImagePath(prodId);
            } else {
                return "no_image.jpg";
            }
        },
        setFilterVendite() {
            if (this.filterVendite == "tutti") {
                this.prodSellData = OriginalProductList;
            } else if (this.filterVendite == "ventuti") {
                this.prodSellData = OriginalProductList.filter(
                    (prod) => prod.qty_tot > 0
                );
            } else if (this.filterVendite == "non_venduti") {
                this.prodSellData = OriginalProductList.filter(
                    (prod) => prod.qty_tot == 0
                );
            }
        },
    },
    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    },
};
</script>
<style scoped lang="scss">
:deep(.v-menu__content.theme--light.menuable__content__active) {
    z-index: 1003 !important;
}
</style>
